import { CommonModule, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

import { StatusFlowStage } from './status-flow.interfaces';

@Component({
  selector: 'app-status-flow',
  standalone: true,
  imports: [CommonModule, NgClass],
  templateUrl: './status-flow.component.html',
  styleUrl: './status-flow.component.scss',
})
export class StatusFlowComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) value: string;
  @Input({ required: true })
  stages: StatusFlowStage[] = [];

  protected valueIndex = 0;

  ngOnChanges(): void {
    this.updateStages();
  }

  private updateStages(): void {
    if (!this.value) return;
    this.valueIndex = this.stages.findIndex((s) => s.value === this.value);
  }
}
